import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleVesselQhse = {
  namespaced: true,

  state: {
    name: 'vessel-qhse',
    qhses: [],
  },

  mutations,
  getters,
  actions
}

export default moduleVesselQhse;